(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-drawer"] && !Shopify.designMode) return;
  try {
    class CartDrawer extends HTMLElement {
    constructor() {
      super();
      this.onKeydown = this.onKeydown.bind(this);
      this.onRefresh = this.onRefresh.bind(this);
      this.lastFocus = null;
      this.closeTimer = null;
    }

    connectedCallback() {
      this.bindPanel();
      this.bindOpeners();
      document.addEventListener('keydown', this.onKeydown);
      document.addEventListener('cart:refresh', this.onRefresh);
    }

    disconnectedCallback() {
      document.removeEventListener('keydown', this.onKeydown);
      document.removeEventListener('cart:refresh', this.onRefresh);
    }

    // (Re)bind elements that live inside the drawer — called again after a refresh
    // swaps the inner markup.
    bindPanel() {
      this.panel = this.querySelector('[data-cart-drawer]');
      this.overlay = this.querySelector('[data-cart-drawer-overlay]');
      this.querySelectorAll('[data-cart-drawer-close]').forEach((el) =>
        el.addEventListener('click', () => this.close())
      );
      if (this.overlay) this.overlay.addEventListener('click', () => this.close());
    }

    // Openers live outside the drawer (e.g. the header bag icon). Their element
    // identity is stable across refreshes, so guard against double-binding.
    bindOpeners() {
      document.querySelectorAll('[data-cart-drawer-open]').forEach((el) => {
        if (el.dataset.cartDrawerBound) return;
        el.dataset.cartDrawerBound = 'true';
        el.addEventListener('click', (e) => {
          e.preventDefault();
          this.open(el);
        });
      });
    }

    get isOpen() {
      return this.panel && this.panel.dataset.active !== undefined;
    }

    open(trigger) {
      if (!this.panel) return;
      this.lastFocus = trigger || document.activeElement;
      window.clearTimeout(this.closeTimer);
      this.panel.hidden = false;
      requestAnimationFrame(() => {
        this.panel.dataset.active = '';
        if (this.overlay) this.overlay.dataset.active = '';
      });
      document.documentElement.style.overflow = 'hidden';
      requestAnimationFrame(() => this.panel.focus());
      document.dispatchEvent(new CustomEvent('cart-drawer:open'));
    }

    close() {
      if (!this.panel) return;
      delete this.panel.dataset.active;
      if (this.overlay) delete this.overlay.dataset.active;
      document.documentElement.style.overflow = '';
      this.closeTimer = window.setTimeout(() => {
        this.panel.hidden = true;
      }, 300);
      if (this.lastFocus && typeof this.lastFocus.focus === 'function') {
        try { this.lastFocus.focus(); } catch (e) {}
      }
      document.dispatchEvent(new CustomEvent('cart-drawer:close'));
    }

    onKeydown(e) {
      if (e.key === 'Escape' && this.isOpen) this.close();
    }

    // The market is decided by the URL prefix (/en-ie, /en-fr, …) — cookies don't
    // override it. A section render on a bare path therefore comes back in the
    // default GB market, which would repaint every `| money` in this drawer in
    // pounds. routes.root_url is Liquid-rendered for the CURRENT market, so
    // re-prefixing a pathname that has lost it is a no-op everywhere else.
    sectionsUrl() {
      const root = ((window.routes && window.routes.root_url) || '/').replace(/\/+$/, '') || '/';
      const path = window.location.pathname;
      if (root !== '/' && path !== root && path.indexOf(root + '/') !== 0) {
        return root + path + '?sections=header';
      }
      return path + '?sections=header';
    }

    // Pull fresh server-rendered markup for the header section (which contains both
    // the drawer and the bag-icon count) and swap it in. Triggered by `cart:refresh`;
    // pass `{ detail: { open: true } }` to also slide the drawer open afterwards.
    async onRefresh(e) {
      const shouldOpen = !!(e && e.detail && e.detail.open);
      const wasOpen = this.isOpen;

      try {
        const res = await fetch(this.sectionsUrl());
        if (res.ok) {
          const data = await res.json();
          const markup = data.header;
          if (markup) {
            const doc = new DOMParser().parseFromString(markup, 'text/html');

            const freshDrawer = doc.querySelector('cart-drawer');
            if (freshDrawer) {
              this.innerHTML = freshDrawer.innerHTML;
              this.bindPanel();
            }

            const freshBubble = doc.querySelector('#cart-icon-bubble');
            const liveBubble = document.querySelector('#cart-icon-bubble');
            if (freshBubble && liveBubble) liveBubble.innerHTML = freshBubble.innerHTML;
          }
        }
      } catch (err) {
        // Network/parse failure — fall through and still open with whatever's there.
      }

      if (shouldOpen || wasOpen) this.open(this.lastFocus);
    }
  }

  if (!customElements.get('cart-drawer')) {
    customElements.define('cart-drawer', CartDrawer);
  }
  } catch(e) { console.error(e); }
})();

})();
